/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * F032 step 7b: the Archive confirm, in the Programming list's words.
 */
import React from "react";
import {
  Alert,
  AlertDescription,
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Spinner,
} from "@lemonadetraining/web-ui";

export interface ArchiveProgramDialogProps {
  open: boolean;
  name: string;
  busy: boolean;
  error?: string | null;
  onConfirm: () => void;
  onClose: () => void;
}

export function ArchiveProgramDialog({
  open,
  name,
  busy,
  error,
  onConfirm,
  onClose,
}: ArchiveProgramDialogProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        // Not dismissable while the archive is in flight.
        if (!next && !busy) onClose();
      }}
    >
      <DialogContent data-testid="archive-confirm-dialog">
        <DialogHeader>
          <DialogTitle>Archive &ldquo;{name}&rdquo;?</DialogTitle>
          <DialogDescription>
            Archiving stops new people from joining. Nothing changes for current members.
          </DialogDescription>
        </DialogHeader>
        <ul className="list-disc space-y-1 pl-5 text-sm text-muted-foreground">
          <li>It comes off your public page and can no longer be bought.</li>
          <li>Members with a monthly price keep access and keep paying until they cancel.</li>
          <li>Members who paid once keep access.</li>
        </ul>
        <p className="text-sm text-muted-foreground">
          To end it for current members too, use End for everyone instead.
        </p>
        {error && (
          <Alert variant="destructive" data-testid="archive-error">
            <AlertDescription>{error}</AlertDescription>
          </Alert>
        )}
        <DialogFooter className="gap-2 sm:gap-0">
          <Button variant="outline" onClick={onClose} disabled={busy}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={busy}
            data-testid="archive-confirm"
          >
            {busy && <Spinner className="mr-2 size-4" />}
            Archive
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default ArchiveProgramDialog;
